import { ratingClasses } from '@mui/material/Rating'
import { svgIconClasses } from '@mui/material/SvgIcon'
import { CssVarsThemeOptions, alpha } from '@mui/material/styles'

// ----------------------------------------------------------------------

export function rating(): CssVarsThemeOptions['components'] {
	return {
		MuiRating: {
			styleOverrides: {
				root: {
					[`&.${ratingClasses.disabled}`]: {
						opacity: 0.48,
					},
				},
				iconEmpty: ({ theme }) => ({
					color: alpha(theme.palette.grey[500], 0.48),
				}),
				sizeSmall: {
					[`& .${svgIconClasses.root}`]: {
						width: 20,
						height: 20,
					},
				},
				sizeMedium: {
					[`& .${svgIconClasses.root}`]: {
						width: 24,
						height: 24,
					},
				},
				sizeLarge: {
					[`& .${svgIconClasses.root}`]: {
						width: 28,
						height: 28,
					},
				},
			},
		},
	}
}
